'use strict';

const localeConfig = tmhDynamicLocaleProvider => {
	tmhDynamicLocaleProvider.localeLocationPattern(
		'/static/vendor/angular-i18n/angular-locale_{{locale}}.js'
	);
};

module.exports = {
	localeConfig
};
